var ContentCollapse = {
  handleContentCollapse: function(e){
    e.preventDefault();

    var parentElement = this.parentElement;  
    let expandableContainer = parentElement.querySelector(".content");
    let innerText = this.dataset.moreText;

    if (expandableContainer.className.match(/hide-content/g)) {
      expandableContainer.className='content show-content';
      innerText = this.dataset.lessText;
    } else {
      expandableContainer.className='content hide-content';
    }        
    this.innerText = innerText;
  },

  onReady: function() {
    var buttons = document.querySelectorAll(".show-more");
    buttons.forEach(element => {
      element.addEventListener("click", this.handleContentCollapse);
    });
  }
}
export default ContentCollapse;
